import React from "react";
import { Box, useTheme, Typography, Button, List, ListItem } from "@mui/material";
import { GifOutlined, History, MonetizationOnOutlined } from "@mui/icons-material";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";

export default function LoyaltyProgram() {
  const theme = useTheme();
  const currentPoints = 800; // This would come from your backend or state management
  
  // Sample prize list. This can be fetched from your backend.
  const prizes = [
    { id: 1, name: "Discount Voucher", points: 500 },
    { id: 2, name: "Free Merchandise", points: 1000 },
    { id: 3, name: "Exclusive Event Pass", points: 2500 },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
            <Header title="LOYALTY PROGRAM" subtitle="Get Points and Claim Rewards" />
      </FlexBetween>
      
      <Box display="flex" alignItems="center" marginBottom={4} marginTop={3}>
        <Box sx={{ marginRight: '5px'}}>
          <MonetizationOnOutlined
          sx={{ color: theme.palette.secondary[500], fontSize: "30px"}}
          />
        </Box>
        <Box marginBottom={0.5}>
          <Typography variant="h5">
            {currentPoints} POINTS
          </Typography>
        </Box>
      </Box>
      
      <Box marginBottom={4}>
        <Typography variant="h5">
          Prizes
        </Typography>
        <List>
          {prizes.map(prize => (
            <ListItem key={prize.id}>
              <GifOutlined style={{marginRight: '10px'}}/>
              {prize.name} - {prize.points} points
              {currentPoints >= prize.points && 
                <Button variant="contained" color="primary" style={{marginLeft: 'auto'}}>
                  Claim
                </Button>
              }
            </ListItem>
          ))}
        </List>
      </Box>

      {/* This is just an example. You can fetch the user's redemption history and display it here. */}
      <Box>
        <Typography variant="h6">
          Redemption History
        </Typography>
        <List>
          <ListItem>
            <History style={{marginRight: '10px'}}/>
            Discount Voucher - 500 points
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};
